import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import "./lib/i18n";
import App from "./App.tsx";
import { LazyPostHogProvider } from "./lib/posthog/LazyPostHogProvider";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { queryClient } from "./lib/queryClient";

// PostHog is disabled by default. Set VITE_PUBLIC_POSTHOG_ENABLED=true to enable
const isPostHogEnabled = import.meta.env.VITE_PUBLIC_POSTHOG_ENABLED === "true";

createRoot(document.getElementById("root")!).render(
	<StrictMode>
		<QueryClientProvider client={queryClient}>
			<LazyPostHogProvider
				apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
				apiHost={import.meta.env.VITE_PUBLIC_POSTHOG_HOST}
				enabled={isPostHogEnabled}
			>
				<App />
			</LazyPostHogProvider>
			{/* React Query DevTools - only loads in development */}
			<ReactQueryDevtools initialIsOpen={false} />
		</QueryClientProvider>
	</StrictMode>,
);
